/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/03/2019
 *
 */

import React, {Component} from 'react';
import Partner from '../Partner/Partner';
import PartnerUrls from '../Partner/PartnerUrls';
import {Switch} from "react-router-dom";
import './mainContent.css';
import Dashboard from "../../containers/Dashboard/Dashboard";
import PartnerForm from "../../components/generic/forms/HOC/partner/partnerForm";
import ProtectedRoute from "../../helper/ProtectedRoute";
import PartnerRole from "../Partner/PartnerRole";
import PartnerRoleForm from "../../components/generic/forms/HOC/partner/partnerRoleForm";
import PartnerUrlForm from "../../components/generic/forms/HOC/partner/partnerUrlForm";
import PartnerUrlTypes from "../Partner/partnerUrlTypes";
import PartnerUrlTypeForm from "../../components/generic/forms/HOC/partner/partnerUrlTypeForm";
import Institutions from "../Institution/Institutions";
import InstitutionsForm from "../../components/generic/forms/HOC/institution/institutionsForm";
import InstitutionUrls from "../Institution/InstitutionUrls";
import InstitutionUrlForm from "../../components/generic/forms/HOC/institution/institutionUrlForm";
import Lms from "../LMS/Lms";
import LmsForm from "../../components/generic/forms/HOC/lms/lmsForm";
import LmsUrlForm from "../../components/generic/forms/HOC/lms/lmsUrlForm";
import ApplicationProperties from "../ApplicationProperties/ApplicationProperties";
import ApplicationPropertiesForm
    from "../../components/generic/forms/HOC/applicationProperties/applicationPropertiesForm";
import LmsProperties from "../LMS/LmsProperties";
import LmsPropertiesForm from "../../components/generic/forms/HOC/lms/lmsPropertiesForm";
import CourseRoles from "../Roles/CourseRoles";
import CourseRolesForm from "../../components/generic/forms/HOC/roles/courseRolesForm";
import AdminRoles from "../Roles/AdminRoles";
import AdminRolesForm from "../../components/generic/forms/HOC/roles/adminRolesForm";
import PearsonRoles from "../PearsonRoles/PearsonRoles";
import PearsonRoleForm from "../../components/generic/forms/HOC/roles/PearsonRoleForm";
import LmsUrl from "../LMS/LmsUrls";
import ViewAudit from "../ViewAudit/ViewAudit";
import ViewError from "../ViewErrors/ViewError";
import Audit from "../Audit/audit";
import ViewErrorDisplay from "../../components/generic/forms/HOC/view-error/viewErrorDisplay";
import AuditDataDisplayForm from "../../components/generic/forms/HOC/audit/auditDataDisplayForm";
import Accounts from "../Accounts/Accounts";
import AccountsForm from "../../components/generic/forms/HOC/accounts/accountsForm";
import ViewAuditDisplay from "../../components/generic/forms/HOC/view-audit/viewAuditDisplay";
import ChangeCredentialsForm from "../../components/generic/forms/HOC/changeCredentialsForm/changeCredentialsForm";
import CoreLogs from "../Logs/coreLogs";
import CoreLogDataDisplayForm from "../../components/generic/forms/HOC/logs/coreLogDataDisplayForm";
import ToolProviders from "../ToolProviders/ToolProviders";
import ToolProvidersForm from "../../components/generic/forms/HOC/toolProviders/toolProvidersForm";
import LmsUrlTypes from "../LMS/LmsUrlTypes";
import LmsUrlTypeForm from "../../components/generic/forms/HOC/lms/LmsUrlTypeForm";
import UrlGroups from "../Others/UrlGroups";
import UrlGroupsForm from "../../components/generic/forms/HOC/others/urlGroupsForm";
import LogMaintForm from "../../components/generic/forms/HOC/logMaint/logMaint";
import Federations from "../Federations/Federations";
import FederationsForm from "../../components/generic/forms/HOC/federations/federationsForm";
import CacheSetupForm from "../../components/generic/forms/HOC/cache/cacheSetupForm";
import CacheSetup from "../cache/CacheSetup";
import ConsumerKey from "../consumer-key/ConsumerKey";
import ConsumerKeyForm from "../../components/generic/forms/HOC/consumer-key/consumerKeyForm";
import ConsumerKeyConfigForm from "../../components/generic/forms/HOC/consumer-key/consumerKeyConfigForm";
import UTF8EnabledToolProfile from "../UTF8ToolProfile/UTF8EnabledToolProfile";
import Utf8EnabledToolProfileForm from "../../components/generic/forms/HOC/utf8toolprofile/utf8EnabledToolProfileForm";
import Utf8DisabledToolProfileForm
    from "../../components/generic/forms/HOC/utf8toolprofile/utf8DisabledToolProfileForm";
import CacheReset from "../cache/CacheReset";
import InstitutionUnblock from "../Institution/InstitutionUnblock";
import InstitutionUnblockForm from "../../components/generic/forms/HOC/institution/institutionUnblockForm";


class MainContent extends Component {
    render() {
        let user = JSON.parse(localStorage.getItem('tmcUser'));
        let componentHome=(user.role=="ROLE_USER"|| user.role=="ROLE_ADMIN")?Partner:(user.role=="ROLE_PRODUCT_ADMIN")?Federations:ViewAudit;
        return(
            <div className="main-content" >
                <Switch>
                    <ProtectedRoute exact path="/home/"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER','ROLE_PRODUCT_ADMIN']} component={componentHome} />

                    <ProtectedRoute exact path="/home/partners"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={Partner} />
                    <ProtectedRoute exact path={["/home/partners/create", "/home/partners/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={PartnerForm} />

                    <ProtectedRoute exact path="/home/partnerRoles"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={PartnerRole} />
                    <ProtectedRoute exact path={["/home/partnerRoles/create", "/home/partnerRoles/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={PartnerRoleForm} />

                    <ProtectedRoute exact path="/home/partnerUrls"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={PartnerUrls} />
                    <ProtectedRoute exact path={["/home/partners/create", "/home/partnerUrls/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={PartnerUrlForm} />

                    <ProtectedRoute exact path="/home/partnerUrlTypes"
                                    roles={['ROLE_ADMIN']} component={PartnerUrlTypes} />
                    <ProtectedRoute exact path={["/home/partnerUrlTypes/create", "/home/partnerUrlTypes/:id"]}
                                    roles={['ROLE_ADMIN']} component={PartnerUrlTypeForm} />

                    <ProtectedRoute exact path="/home/institutions"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={Institutions} />
                    <ProtectedRoute exact path={["/home/Institutions/create", "/home/institutions/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={InstitutionsForm} />

                    <ProtectedRoute exact path="/home/institutionUrls"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={InstitutionUrls} />
                    <ProtectedRoute exact path={["/home/institutionUrls/create", "/home/institutionUrls/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={InstitutionUrlForm} />

                    <ProtectedRoute exact path="/home/institutionUnblock"
                                    roles={['ROLE_PRODUCT_ADMIN']} component={InstitutionUnblock} />
                    <ProtectedRoute exact path={["/home/institutionUnblock/create", "/home/institutionUnblock/:id"]}
                    roles={['ROLE_PRODUCT_ADMIN']} component={InstitutionUnblockForm} />

                    <ProtectedRoute exact path="/home/lms"
                                    roles={['ROLE_ADMIN']} component={Lms} />
                    <ProtectedRoute exact path={["/home/lms/create", "/home/lms/:id"]}
                                    roles={['ROLE_ADMIN']} component={LmsForm} />

                    <ProtectedRoute exact path="/home/lms-properties"
                                    roles={['ROLE_ADMIN']} component={LmsProperties} />
                    <ProtectedRoute exact path={["/home/lms-properties/create", "/home/lms-properties/:id"]}
                                    roles={['ROLE_ADMIN']} component={LmsPropertiesForm} />

                    <ProtectedRoute exact path="/home/lmsUrls"
                                    roles={['ROLE_ADMIN']} component={LmsUrl} />
                    <ProtectedRoute exact path={["/home/lms/create", "/home/lmsUrls/:id"]}
                                    roles={['ROLE_ADMIN']} component={LmsUrlForm} />

                    <ProtectedRoute exact path="/home/lmsUrlTypes"
                                    roles={['ROLE_ADMIN']} component={LmsUrlTypes} />
                    <ProtectedRoute exact path={["/home/lmsUrlTypes/create", "/home/lmsUrlTypes/:id"]}
                                    roles={['ROLE_ADMIN']} component={LmsUrlTypeForm} />

                    <ProtectedRoute exact path="/home/pearson-roles"
                                    roles={['ROLE_ADMIN']} component={PearsonRoles} />
                    <ProtectedRoute exact path={["/home/pearson-roles/create", "/home/pearson-roles/:id"]}
                                    roles={['ROLE_ADMIN']} component={PearsonRoleForm} />

                    <ProtectedRoute exact path="/home/course-roles"
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={CourseRoles} />
                    <ProtectedRoute exact path={["/home/course-roles/create", "/home/course-roles/:id"]}
                                    roles={['ROLE_USER','ROLE_ADMIN']} component={CourseRolesForm} />

                    <ProtectedRoute exact path="/home/admin-roles"
                                    roles={['ROLE_ADMIN']} component={AdminRoles} />
                    <ProtectedRoute exact path={["/home/admin-roles/create", "/home/admin-roles/:id"]}
                                    roles={['ROLE_ADMIN']} component={AdminRolesForm} />

                    <ProtectedRoute exact path="/home/application-properties"
                                    roles={['ROLE_ADMIN']} component={ApplicationProperties} />
                    <ProtectedRoute exact path={["/home/application-properties/create", "/home/application-properties/:id"]}
                                    roles={['ROLE_ADMIN']} component={ApplicationPropertiesForm} />

                    <ProtectedRoute exact path="/home/view-audit"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={ViewAudit} />
                    <ProtectedRoute exact path="/home/view-audit/:id"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={ViewAudit} />
                    {/*<ProtectedRoute exact path="/home/view-audit/:id"*/}
                    {/*                roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={ViewAuditDisplay} />*/}

                    <ProtectedRoute exact path="/home/view-error"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={ViewError} />
                    <ProtectedRoute exact path="/home/view-error/:id"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={ViewErrorDisplay} />

                    <ProtectedRoute exact path="/home/audit"
                                    roles={['ROLE_ADMIN']} component={Audit} />
                    <ProtectedRoute exact path="/home/audit/:id"
                                    roles={['ROLE_ADMIN']} component={AuditDataDisplayForm} />

                    <ProtectedRoute exact path="/home/accounts"
                                    roles={['ROLE_ADMIN']} component={Accounts} />
                    <ProtectedRoute exact path={["/home/accounts/create", "/home/accounts/:id"]}
                                    roles={['ROLE_ADMIN']} component={AccountsForm} />

                    <ProtectedRoute exact path={["/home/changeCredentials"]}
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER','ROLE_PRODUCT_ADMIN']} component={ChangeCredentialsForm} />

                    <ProtectedRoute exact path="/home/coreLogs"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']}  component={CoreLogs} />
                    <ProtectedRoute exact path="/home/coreLogs/:id"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']}   component={CoreLogDataDisplayForm} />

                    <ProtectedRoute exact path="/home/toolProviders"
                                    roles={['ROLE_ADMIN']}  component={ToolProviders} />
                    <ProtectedRoute exact path={["/home/toolProviders/:id"]}
                                    roles={['ROLE_ADMIN']} component={ToolProvidersForm} />

                    <ProtectedRoute exact path="/home/url-groups"
                                    roles={['ROLE_ADMIN']}  component={UrlGroups} />
                    <ProtectedRoute exact path="/home/url-groups/:id"
                                    roles={['ROLE_ADMIN']}   component={UrlGroupsForm} />

                    <ProtectedRoute exact path={["/home/logMaint"]}
                                    roles={['ROLE_ADMIN']} component={LogMaintForm} />

                    <ProtectedRoute exact path="/home/federations"
                                    roles={['ROLE_PRODUCT_ADMIN']} component={Federations} />
                    <ProtectedRoute exact path="/home/federations/:id"
                                    roles={['ROLE_PRODUCT_ADMIN']}   component={FederationsForm} />

                    <ProtectedRoute exact path="/home/utf-enabled-consumer-key/config"
                                    roles={['ROLE_ADMIN']}   component={ConsumerKeyConfigForm} />
                    <ProtectedRoute exact path="/home/utf-enabled-consumer-key"
                                    roles={['ROLE_ADMIN']} component={ConsumerKey} />
                    <ProtectedRoute exact path="/home/utf-enabled-consumer-key/:id"
                                    roles={['ROLE_ADMIN']}   component={ConsumerKeyForm} />
                    <ProtectedRoute exact path="/home/utf-enabled-consumer-key/filter"
                                    roles={['ROLE_ADMIN']}   component={ConsumerKeyForm} />

                    <ProtectedRoute exact path="/home/utf8EnabledToolProfile"
                                    roles={['ROLE_ADMIN']} component={UTF8EnabledToolProfile} />
                    <ProtectedRoute exact path="/home/utf8EnabledToolProfile/create"
                                    roles={['ROLE_ADMIN']} component={Utf8EnabledToolProfileForm} />
                    <ProtectedRoute exact path="/home/utf8EnabledToolProfile/:id"
                                    roles={['ROLE_ADMIN']} component={Utf8DisabledToolProfileForm} />
                    <ProtectedRoute exact path="/home/cache-setup"
                                    roles={['ROLE_PRODUCT_ADMIN']}  component={CacheSetup} />
                    <ProtectedRoute exact path="/home/cache-setup/:id"
                                    roles={['ROLE_PRODUCT_ADMIN']}   component={CacheSetupForm} />

                    <ProtectedRoute exact path="/home/cache-reset"
                                    roles={['ROLE_PRODUCT_ADMIN']}  component={CacheReset} />
                    <ProtectedRoute exact path="/home/cache-setup/:id"
                                    roles={['ROLE_PRODUCT_ADMIN']}   component={CacheSetupForm} />


                    <ProtectedRoute path="/**"
                                    roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER']} component={Partner} />

                </Switch>
            </div>
        )
    }
}

export default MainContent;
